import { useCallback, useMemo } from 'react';

import { showToast } from '@features';
import { getCommentsToastScope } from '@widgets/Comments/lib/helpers';

export const useCommentsErrorToast = (positionGuid: string) => {
    const toastScope = useMemo(() => getCommentsToastScope(positionGuid), [positionGuid]);

    const showErrorToast = useCallback(
        (errorText: string) => {
            showToast(errorText, { scope: toastScope, type: 'error' });
        },
        [toastScope]
    );

    return { showErrorToast };
};
